import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ModuleRoutingModule } from './module-routing.module';
import { RegisterComponent } from './register/register.component';
import { OtpComponent } from './otp/otp.component';
import { ApiService } from '../service/api.service';
import { NgOtpInputModule } from  'ng-otp-input';

@NgModule({
  declarations: [
    RegisterComponent, 
    OtpComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgOtpInputModule,
    ModuleRoutingModule
  ],providers:[]
})
export class ModuleModule { }
